<template>
    <div class="Y-c">
        <breadcrumb :routerList="[{to:'/dingd/bsc',title:'订单预测评估'}]"/>
        <div class="h-piece h-mrt30 yuce">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                    <el-form-item label="系列">
                        <el-input v-model="xilie" placeholder="请输入内容" ></el-input>
                    </el-form-item>
                    <el-form-item label="产品型号" style="margin-left:10px;">
                        <el-select v-model="formInline.customerName" placeholder="模糊查询" style="width:2.1rem;">
                            <el-option label="客户一" value="1"></el-option>
                            <el-option label="客户二" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产品编码" style="margin-left:10px;">
                        <el-input v-model="input" placeholder="请输入内容" ></el-input>
                    </el-form-item>
                    <el-form-item label="销售区域" style="margin-left:10px;" >
                    <el-select v-model="formInline.type" placeholder="请选择">
                        <el-option label="类别1" value="1"></el-option>
                        <el-option label="类别2" value="2"></el-option>
                    </el-select> 
                    </el-form-item>
                    <div style="float:right;margin-top:-45px;">
                        <el-button class="h-btn h-formBtn" style="margin-left:20px;margin-top:-10px;">检索</el-button>
                        <el-button class="h-btn h-formBtn" style="background-color:white;color:black;border:1px solid #d1d1d1" @click="resetData">重置</el-button>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="h-table h-mrt30 Y-b" v-if="clickActive==1">
			<el-table
				ref="multipleTable"
				:data="tableData2"
				stripe
				border
				style="width: 100%"
				>
				<el-table-column
				  fixed
                  prop="xilie"
				  label="系列"
				  width="50">
				</el-table-column>
				<el-table-column
				  prop="xianti"
				  label="线体"
				  width="60">
				</el-table-column>
				<el-table-column
				  label="型号"
				  width="100">
                    <template >
                        <el-select v-model="value" placeholder="--请选择--">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
				</el-table-column>
				<el-table-column
				  prop="contact"
				  label="产品编码"
				  width="70">
				</el-table-column>
				<el-table-column
				  prop="quyu"
				  label="区域预测"
				  width="100">
				</el-table-column>
				<el-table-column
				  prop="Lastmonth"
				  label="去年月均"
				  width="100">
				</el-table-column>
				<el-table-column
				  prop="lastYF"
				  label="前年月均"
				  width="120">
				</el-table-column>
                <el-table-column
				  prop="compile"
				  label="上年度Q4月均"
				  width="80">
				</el-table-column>
                <el-table-column
				  prop="thesameyear"
				  label="当年累计月均"
				  width="80">
				</el-table-column>
                <el-table-column
				  prop="yearsales"
				  label="当年累计月均"
				  width="80">
				</el-table-column>
                <el-table-column
				  prop="Monthlycycle"
				  label="当年累计月均"
				  width="80">
				</el-table-column>
                <el-table-column
				  prop="throwaway"
				  label="散单纠偏"
				  width="130">
                    <template scope="scope">
                        <el-input v-model="scope.row.throwaway"></el-input>
                    </template>
				</el-table-column>
                <el-table-column
				  prop="gongcheng"
				  label="工程项目"
				  :show-overflow-tooltip="true"
				  width="80">
                    <template scope="scope">
                        <el-input v-model="scope.row.gongcheng"></el-input>
                    </template>
				</el-table-column>
                <el-table-column
				  prop="audit"
				  label="未审核"
				  width="80">
				</el-table-column>
                <el-table-column
				  prop="totalP"
				  label="已排产未下线"
				  width="80">
                  <div class="paichan">
                      <span>数量:{{paichan}}</span></div>
                      <hr>
                  <div><span>时间:{{time}}</span></div>
				</el-table-column>
                <el-table-column
				  prop="huoyuan"
				  label="货源预估"
				  width="80">
                    <template scope="scope">
                        <el-input v-model="scope.row.huoyuan"></el-input>
                    </template>
				</el-table-column>
			</el-table>
		</div>
        <div class="h-tableB h-mrt30 left">
            <div class="h-tableBL">
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="downloadExcel">
                    批量导出
                </el-button>
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="daoru">批量导入</el-button>
            </div>
            <div class="h-pagination2">
                <pagination :page="q" @query="query"/>
            </div>
        </div>
        <el-dialog :visible.sync="dialogFormVisible2" width="53%" class="h-dialog3 dialogFormVisible3">
                <div class="h-dialogImg">
                    <div style="display:flex;align-items:center;">
                        <img src="../../../assets/images/daoru-j.png" alt="" style="width: 86px;height: 86px;">
                        <div>
                            <p class="piliang1">批量导入</p>
                            <p class="piliang2">导入文件请先下载模版并按照模版填写完成后，点击上传文件，上传文件不大于200M</p>
                        </div>
                    </div>
                    
                    <div class="piliangBox">
                        <div class="imgs"><img src="../../../assets/images/daoru-exls.png" alt=""
                                               style="width: 40px;height: 39px;"></div>
                        <div class="imgs">批量导入模版文件.xlsx</div>
                        <div class="imgs" style="color: #0865c4;cursor:pointer;">下载</div>
                    </div>
                    <div style="width:100%;">
                        <el-upload
                                action="https://jsonplaceholder.typicode.com/posts/"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemove"
                                style="width:100%;">
                            <div style="width:100%;">+ 上传文件</div>
                        </el-upload>
                    </div>
                    <div style="display:flex;justify-content:center;margin-top:30px;">
                        <el-button class="h-btn h-formBtn h-bgwhite" type="primary" @click="dialogFormVisible2 = false">
                            取消
                        </el-button>
                        <el-button class="h-btn h-formBtn" type="primary" style="margin-left:40px;"
                                   @click="dialogFormVisible2 = false">提交
                        </el-button>
                    </div>
                </div>
            </el-dialog>
    </div>
</template>

<script>
export default {
    data () {
        return {
            dialogFormVisible2:false,
            time:'2019-10-30',
            paichan:'17',
            options: [{
                value: '选项1',
                label: '黄金糕'
                }, {
                value: '选项2',
                label: '双皮奶'
                }, {
                value: '选项3',
                label: '蚵仔煎'
                }, {
                value: '选项4',
                label: '龙须面'
                }, {
                value: '选项5',
                label: '北京烤鸭'
                }],
            value:'',
            tableData: [{
                id: '12987122',
                name: '好滋好味鸡蛋仔',
                category: '江浙小吃、小吃零食',
                desc: '荷兰优质淡奶，奶香浓而不腻',
                address: '上海市普陀区真北路',
                shop: '王小虎夫妻店',
                shopId: '10333'
            }],
            clickActive:1,
            input:'',
            xilie:'',
            input1:'',
            formInline:{
				customerName:'',
				date3:'2',
                type:'',
                
            },
            tableData2: [{
                xilie: '冷柜',
                xianti:'线体',
                xinghao: 'KHSHS3496',
                contact: 'SJJ4745',
                quyu: '￥35000',
                Lastmonth: '￥35000',
                Yblastmonth: '￥35000',
                lastYF:'￥35000',
                compile:'￥35000',
                thesameyear:'￥35000',
                yearsales:'87',
                Monthlycycle:'645',
                gongcheng:'',
                audit:'16',
                xiaxian:'',
                huoyuan:''
                },
                {
				xilie: '冷柜',
                xianti:'线体',
                xinghao: 'KHSHS3496',
                contact: 'SJJ4745',
                quyu: '￥35000',
                Lastmonth: '￥35000',
                Yblastmonth: '￥35000',
                lastYF:'￥35000',
                compile:'￥35000',
                thesameyear:'￥35000',
                yearsales:'87',
                Monthlycycle:'645',
                gongcheng:'',
                audit:'16',
                xiaxian:'',
                huoyuan:''
                },
                {
				xilie: '冷柜',
                xianti:'线体',
                xinghao: 'KHSHS3496',
                contact: 'SJJ4745',
                quyu: '￥35000',
                Lastmonth: '￥35000',
                Yblastmonth: '￥35000',
                lastYF:'￥35000',
                compile:'￥35000',
                thesameyear:'￥35000',
                yearsales:'87',
                Monthlycycle:'645',
                gongcheng:'',
                audit:'16',
                xiaxian:'',
                huoyuan:''
                },
                {
				xilie: '冷柜',
                xianti:'线体',
                xinghao: 'KHSHS3496',
                contact: 'SJJ4745',
                quyu: '￥35000',
                Lastmonth: '￥35000',
                Yblastmonth: '￥35000',
                lastYF:'￥35000',
                compile:'￥35000',
                thesameyear:'￥35000',
                yearsales:'87',
                Monthlycycle:'645',
                gongcheng:'',
                audit:'16',
                xiaxian:'',
                huoyuan:''
                },
                {
				xilie: '冷柜',
                xianti:'线体',
                xinghao: 'KHSHS3496',
                contact: 'SJJ4745',
                quyu: '￥35000',
                Lastmonth: '￥35000',
                Yblastmonth: '￥35000',
                lastYF:'￥35000',
                compile:'￥35000',
                thesameyear:'￥35000',
                yearsales:'87',
                Monthlycycle:'645',
                gongcheng:'',
                audit:'16',
                xiaxian:'',
                huoyuan:''
                },
                {
				xilie: '冷柜',
                xianti:'线体',
                xinghao: 'KHSHS3496',
                contact: 'SJJ4745',
                quyu: '￥35000',
                Lastmonth: '￥35000',
                Yblastmonth: '￥35000',
                lastYF:'￥35000',
                compile:'￥35000',
                thesameyear:'￥35000',
                yearsales:'87',
                Monthlycycle:'645',
                gongcheng:'',
                audit:'16',
                xiaxian:'',
                huoyuan:''
                },
                {
				xilie: '冷柜',
                xianti:'线体',
                xinghao: 'KHSHS3496',
                contact: 'SJJ4745',
                quyu: '￥35000',
                Lastmonth: '￥35000',
                Yblastmonth: '￥35000',
                lastYF:'￥35000',
                compile:'￥35000',
                thesameyear:'￥35000',
                yearsales:'87',
                Monthlycycle:'645',
                gongcheng:'',
                audit:'16',
                xiaxian:'',
                huoyuan:''
                },
                {
				xilie: '冷柜',
                xianti:'线体',
                xinghao: 'KHSHS3496',
                contact: 'SJJ4745',
                quyu: '￥35000',
                Lastmonth: '￥35000',
                Yblastmonth: '￥35000',
                lastYF:'￥35000',
                compile:'￥35000',
                thesameyear:'￥35000',
                yearsales:'87',
                Monthlycycle:'645',
                gongcheng:'',
                audit:'16',
                xiaxian:'',
                huoyuan:''
                },
                {
				xilie: '冷柜',
                xianti:'线体',
                xinghao: 'KHSHS3496',
                contact: 'SJJ4745',
                quyu: '￥35000',
                Lastmonth: '￥35000',
                Yblastmonth: '￥35000',
                lastYF:'￥35000',
                compile:'￥35000',
                thesameyear:'￥35000',
                yearsales:'87',
                Monthlycycle:'645',
                gongcheng:'',
                audit:'16',
                xiaxian:'',
                huoyuan:''
                },
                {
				xilie: '冷柜',
                xianti:'线体',
                xinghao: 'KHSHS3496',
                contact: 'SJJ4745',
                quyu: '￥35000',
                Lastmonth: '￥35000',
                Yblastmonth: '￥35000',
                lastYF:'￥35000',
                compile:'￥35000',
                thesameyear:'￥35000',
                yearsales:'87',
                Monthlycycle:'645',
                gongcheng:'',
                audit:'16',
                xiaxian:'',
                huoyuan:''
				}]
        }
    },
    methods: {
        resetData(){
                this.xilie = '';
                this.formInline.customerName = '';
                this.input = '';
                this.formInline.type = '';
                this.query();
                this.$message({
                    type: "success",
                    message: '已成功重置'
                });
            },
            daoru() {
                this.dialogFormVisible2 = true;
            },
    }
}
</script>

<style scoped>
    .left{
        margin-left: 20px;
    }
   
   .Y-b{
       margin: 20px;
   }
   .yuce{
       margin-left: 20px;
       margin-right: 20px;
       
   }
   .h-formBtnOut{
       margin-top: 0px;
       margin-left: 20px;
       background-color: blue;
       border:none;
       border-radius: 4px;
   }
  
</style>
<style>
     .h-crumbOut .h-piece .h-formBox .el-form .jiansuo{
        margin-top: 0;
    }
    .Y-b > .el-select{
       padding: 0;
       margin: 0;
   }
   /* .el-table__body .el-table__row .cell{
        padding: 0;
        height: 40px;
        line-height: 40px;
    } */
    /* .Y-c .yuce .h-formBox .demo-form-inline .area{
       vertical-align:text-top;
   } */
</style>


